/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonIconSquare/view.blocks to change it.
import ArrowLeft from 'DesignSystem/Svgs/ArrowLeft/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonIconSquare({
  children,
  viewPath = "/DesignSystem/ButtonIconSquare",
  backgroundColor = "#ffffff",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderColor = "#ebebeb",
  borderStyle = "solid",
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  borderWidth = 1,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  onClick,
  paddingBottom = 16,
  paddingLeft = 15,
  paddingRight = 15,
  paddingTop = 16
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="ButtonIconSquare.ButtonIconSquare:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-1xBFqK': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-1xBFqK': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--bs-5-1xBFqK': borderStyle,'--btlr-6-1xBFqK': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-7-1xBFqK': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bw-8-1xBFqK': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--mb-9-1xBFqK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-10-1xBFqK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-11-1xBFqK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-12-1xBFqK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--pb-13-1xBFqK': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-14-1xBFqK': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-15-1xBFqK': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-16-1xBFqK': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--bc-1-1xBFqK': isHovered ? "rgba(0, 234, 141, 0.05)" : backgroundColor,'--bc-4-1xBFqK': isHovered ? "rgba(0, 188, 112, 0.83)" : borderColor}}
 className={`views-block ${styles.ButtonIconSquare1}`}
>
<ArrowLeft
  viewPath={`${viewPath}/ArrowLeft`}
 height={20}
 proxy={true}
 width={20}
/>
</button>
{children}
</React.Fragment>)
}